import { AccessibilityStatement } from '@gjl/ui'
import { useSEO } from '@/hooks/useSEO'

export default function AccessibilityPage() {
  useSEO({
    title: 'Accessibility',
    description:
      'Fugue Lab is committed to WCAG 2.1 AA accessibility. Learn about the measures we take to ensure our site is usable by everyone.',
    url: '/accessibility',
    canonical: '/accessibility',
  })

  return (
    <AccessibilityStatement
      orgName="Fugue Lab"
      contactEmail="hello@fuguelab.com"
      siteUrl="fuguelab.com"
      knownLimitations={[
        'Some embedded third-party content (Calendly booking widget) may have limited screen reader support',
      ]}
      lastUpdated="April 8, 2026"
    />
  )
}
